module.exports = __webpack_public_path__ + "img/03d.227c18cb.png";